
import { User } from '../entities/user/user.model';
import { AuthActions, AuthActionTypes } from './auth.actions';

export interface AuthState {
  loggedUser: User;
  // authResult: AuthResult;
  selectedLanguageCode: string;
  showInformationAgreementPopup: boolean;
}

export const initialState: AuthState = {
  loggedUser: null,
  // authResult: null,
  selectedLanguageCode: '',
  showInformationAgreementPopup: false
};


// // this function updates a form group state based on the passed
// // update functions (see the sections below for more details on
// // all available update functions as well as on updating groups)
// export const validateForm = updateGroup<UserFormValue>({
//   firstName: validate(required),
//   lastName: validate(required),
//   email: validate(required, email),
//   role: disable,
//   company: disable
// });


export function authReducer(
  state: AuthState = initialState,
  action: AuthActions
): AuthState {
  switch (action.type) {
    case AuthActionTypes.GetLoggedUserSuccess:
      return { ...state, loggedUser: action.loggedUser };

    case AuthActionTypes.Logout:
      return { ...state, loggedUser: null };

    case AuthActionTypes.ChangeLanguage:
      return { ...state, selectedLanguageCode: action.languageCode };

    case AuthActionTypes.ShowInformationAgreementPopup:
      return {
          ...state,
          showInformationAgreementPopup: true,
      };

    case AuthActionTypes.HideInformationAgreementPopup:
      return { ...state, showInformationAgreementPopup: false };

    case AuthActionTypes.AcceptInformationAgreementSuccess:
      return { ...state, showInformationAgreementPopup: !action.informationAgreement };

    default:
      return state;
  }
}
